import { Location } from '@angular/common';
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationStart, Router } from '@angular/router';
import { ConfigService } from '@services/config.service';
import { RoleManagementService } from '@services/role.management.service';
import { AppService } from './services/app.service';
import { IdleService } from './shared/idle.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { AudioConfig, SpeakerAudioDestination, SpeechConfig, SpeechRecognizer, SpeechSynthesizer } from 'microsoft-cognitiveservices-speech-sdk';
// import { environment } from 'src/environments/environment';
// import Speech from 'speak-tts';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,AfterContentChecked {
  title = 'assesment';
  fullyear = new Date().getFullYear();

  userHeader: number;
  isFisrtTimeLoaded = true;
  previousUrl: string;
  currntRout: any
  contentVisible = false;
  browserLang: string;
  isTestDeliveryUrl = false;
  
  constructor(
    private location: Location,
    private renderer: Renderer2,
    private router: Router,
    private appService: AppService,
    private configService: ConfigService,
    private roleManagementService: RoleManagementService,
    private idleService: IdleService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
    public snackBar: MatSnackBar
  ) {
    this.configService.configTheme();
    // Set Multilingual Localization
    // translate.addLangs(['en-US', 'es-ES'])
    // translate.setDefaultLang('en-US');
    // this.browserLang = localStorage.getItem('language');
    // if (this.browserLang == null || undefined || '') {
    //   translate.use('en-US');
    // } else {
    //   translate.use(this.browserLang);
    // }
  }


  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  showSubmenu = false;
  isShowing = false;
  showSubSubMenu = false;
  showSubmenu1 = false;
  showSubSubMenu1 = false;
  showSubmenu2 = false;
  showSubSubMenu2 = false;
  showSubmenu3 = false;
  showSubSubMenu3 = false;

  mouseenter(): void {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave(): void {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  // Listen for the browser tab close event
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler(event: any) {
  //   const rememberMeFlag = localStorage.getItem('rememberMe')    
  //   const sessionDataUser = sessionStorage.getItem('currentUser');
  //   const sessionDataColId = sessionStorage.getItem('defaultcollectionid');
  //   const sessionDataColUUId = sessionStorage.getItem('defaultcollectionuuid');
  //   if (rememberMeFlag) {
  //     localStorage.setItem('currentUser', sessionDataUser); 
  //     localStorage.setItem('defaultcollectionid', sessionDataColId); 
  //     localStorage.setItem('defaultcollectionuuid', sessionDataColUUId); 
  //     console.log('Data moved from sessionStorage to localStorage');
  //   }
  // }

  ngOnInit(): void {
    const currentUserLocalStorage = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const rememberMeFlag = localStorage.getItem('rememberMe'); 
    if(document.URL.includes('/td/login') || 
    document.URL.includes('/td/twoFactorAuthD') ||
    document.URL.includes('delivery/start/test') || 
    document.URL.includes('delivery/test/result/')){
      this.isTestDeliveryUrl = true
    }
    if (rememberMeFlag == 'true' && Object.keys(currentUserLocalStorage).length !== 0 && !this.isTestDeliveryUrl) {
      const localDataUser = localStorage.getItem('currentUser');
      const localDataColId = localStorage.getItem('defaultcollectionid');
      const localDataColUUId = localStorage.getItem('defaultcollectionuuid');
      // Store again in sessionstorage
      sessionStorage.setItem('currentUser', localDataUser);
      sessionStorage.setItem('defaultcollectionid', localDataColId);
      sessionStorage.setItem('defaultcollectionuuid', localDataColUUId);
      const collectionUUID = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'))
      this.router.navigate([`/collections/${collectionUUID}/home`]).then(()=>{
        if (!sessionStorage.getItem('pageReloaded')) {
          // Reload the page once
          window.location.reload();
          sessionStorage.setItem('pageReloaded', 'true');
        } else {
          sessionStorage.removeItem('pageReloaded');
        }
      }) 
      console.log(collectionUUID)
    } else {
      const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
      if (Object.keys(currentUserFromStorage).length === 0 || currentUserFromStorage.roleDetails.privileges.length === 0) {
        this.appService.changeUserHeader(0);
      }
      else {
        this.appService.changeUserHeader(1);
      }
    }
    this.location.onUrlChange(url => {
      // this.roleManagementService.getAccessDetails(this.roleManagementService.getFeatureFromUrl(url), this.roleManagementService.redirectToDefaultPage);
      if (url.includes('delivery')) {
        this.appService.changeUserHeader(0);
        return;
      }
    })
    

    this.appService.userHeader.subscribe(data => {
      this.userHeader = data;
    });

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.previousUrl) {
            this.renderer.removeClass(document.body, this.previousUrl);
          }
          let currentUrlSlug = event.url.slice(1)
          if (currentUrlSlug) {
            this.renderer.addClass(document.body, currentUrlSlug.replace(/[\/ ]/g, '-'));
          }
          this.previousUrl = currentUrlSlug.replace(/[\/ ]/g, '-');
        }
      });
  }

  // Idle time host listeners
  @HostListener('mousemove', ['$event'])
  @HostListener('mousedown', ['$event'])
  @HostListener('scroll', ['$event'])
  @HostListener('keydown', ['$event'])
  handleUserActiveState(): void {
    this.idleService.reset();
  }

  ngAfterContentChecked(): void {
    setTimeout(() => { this.contentVisible = true; }, 50);
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      setTimeout(() => { this.snackBar.dismiss(); }, 5000);
    }
  }

  LogOut(): void {
    sessionStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
  }
}
